/* eslint-disable no-nested-ternary */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable arrow-body-style */

import React, {useState ,useEffect} from 'react';
import Select, { components } from "react-select";

const Option = props => {
  
  const [isMobileDevice, setIsMobileDevice] = useState(window.innerWidth <= 500)
  const handleWindowSizeChange = () => {
    setIsMobileDevice(window.innerWidth <= 500);
  }
  
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />
        <label style={ {fontSize:isMobileDevice ? "10px" : "14px"}}>{props.label}</label>
      </components.Option>
    </div>
  );
};

const MultiValue = props => {
  return (
    <components.MultiValue {...props}>
      <span>{props.data.label}</span>
    </components.MultiValue>
  );
};


const MultiSelect=({options,className,onChange,isMandatory,isDisabled,markIfUnselected,value,showError,widths})=>{
    const [isVisited, setIsVisited] = useState(false); 

    const [isMobileDevice, setIsMobileDevice] = useState(window.innerWidth <= 500)

    const handleWindowSizeChange = () => {
      setIsMobileDevice(window.innerWidth <= 500);
    }
    
    useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
      }
    }, []);

  const shouldMarkRed =
    ((isMandatory && isVisited) || markIfUnselected) && !value && !isDisabled;

  const error = shouldMarkRed || showError;
  return(
    <>
      <Select
        closeMenuOnSelect={false}
        isMulti
        components={{ Option, MultiValue }}
        className={className}
        options={options}
        hideSelectedOptions={false}
        backspaceRemovesValue={false}
        onChange={onChange}
        styles={{
        control: (provided, state) => ({
          ...provided,
          minHeight: '35px',
          height: '100%',
          fontSize:isMobileDevice ? "10px" : "14px",
          borderColor: state.isFocused ? '#E9DEAE' : '#c4c4c4',
          boxShadow: state.isFocused && '0 0 0 1px #E9DEAE',
          backgroundColor: state.isDisabled ? '#f3f5f9' : '#fff',
          ...(error && {
            borderColor: 'red',
            outline: 'none',
            '&:hover': {
              borderColor: 'red',
            },
          }),
          '&:hover': {
            borderColor: '#E9DEAE'
          },
        }),
        menu: styles => ({ ...styles, width: "100%"
          // width:isMobileDevice ? "100px": widths ? widths : "100%"
         }),
      }}
      /></>
  )
}

export default MultiSelect